import styled from 'styled-components'

const Filters = styled.div`
  > * {
    margin: 0 4px;
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 8px;
    }
  }
  .MuiGrid-root {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
`

const TableFiltersWrap = ({ children }) => <Filters className="filter-field-wrapper">{children}</Filters>

export default TableFiltersWrap
